@if (ppLimitedWorkspaces) {
  <section class="dashletFlip__banner">
    <pp-icon [ppSrc]="EIconPath.ICON_BANNER_INFO_18" ppColor="grey-700" ppClass="setSize18"></pp-icon>
    {{ 'asset_workspaces_limit_info' | ppTranslate }}
  </section>
}

<section class="dashletFlip__header">
  <h6 class="dashletFlip__title">
    {{ 'select_site' | ppTranslate | uppercase }}
  </h6>

  <p class="dashletFlip__section-description">
    {{ 'choose_sites_data_display' | ppTranslate }}
  </p>
</section>

<ul class="dashletFlip__accounts">
  @if (!ppLimitedWorkspaces) {
    <li class="dashletFlip__account-wrapper" (click)="clearSiteRange()">
      <pp-checkbox
        [ppChecked]="!ppSiteRange.workspaceIds?.length && !ppSiteRange.accountId"
      ></pp-checkbox>
      <p class="dashletSiteacc__acc-label">{{ 'all_accounts_sites' | ppTranslate }}</p>
    </li>
  }

  @if (filteredAccounts?.length > 0) {
    @for (account of filteredAccounts; track account) {
      <li
        class="dashletFlip__account"
      [ngClass]="{
        'dashletFlip__account--active':
          account.accountId === ppSiteRange.accountId && !ppSiteRange.workspaceIds?.length,
      }"
        >
        <span class="dashletFlip__account-wrapper" (click)="toggleAccount(account.accountId)">
          @if (!ppLimitedWorkspaces) {
            <pp-checkbox
              [ppChecked]="ppSiteRange.accountId === account.accountId"
              [ppDisabled]="ppLimitedWorkspaces"
            ></pp-checkbox>
          }
          <p
            class="dashletSiteacc__acc-label"
            [class.dashletSiteacc__acc-label--disabled]="ppLimitedWorkspaces"
            >
            {{ account.accountName }} - {{ 'all_sites' | ppTranslate }}
          </p>
        </span>
        <pp-dashlet-timeline-account-multiple
          [ppAccount]="account"
          [ppLimitedWorkspaces]="ppLimitedWorkspaces"
          [ppDashlet]="ppDashlet"
          [ppSiteRange]="ppSiteRange"
          [ppBlockedTimelines]="disabledWorkspaces"
          [ppDefaultWorkspaces]="ppDefaultWorkspaces"
          [ppWorkspaces]="workspaces"
          (ppUpdateSiteRange)="updateSiteRange($event)"
        ></pp-dashlet-timeline-account-multiple>
      </li>
    }
  }
</ul>
